import React from "react"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"

class PrivacyPolicy extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <Typography className={classes.subHeader}>Privacy Policy</Typography>

        <Typography className={classes.paragraph}>
          The privacy of your data is important to us. The only time we’ll ever
          access your account is to help you with a problem or address a bug.
          We’ll never open any uploaded files unless you ask us to. We log all
          access to all accounts by IP address, so we can always verify that no
          unauthorized access has happened for as long as the logs are kept.
        </Typography>

        <Typography className={classes.subHeader}>Identity & Access</Typography>

        <Typography className={classes.paragraph}>
          If you decide to use our ADesk™ service, any personal information we
          receive from you (e.g., your email address) will be stored and shared
          with interested production related parties. You have the right to mark
          any personal information as private. When marked as private only
          specific related parties will be provided the data relating to a
          specific commercial activity. When you write ADesk™ with a question or
          to ask for help, we’ll keep that correspondence, and the email
          address, for future reference. When you browse our marketing pages,
          we’ll track that for statistical purposes (such as conversion rates
          and to test new designs). We also store any information you volunteer,
          such as surveys, for as long as it makes sense.
        </Typography>

        <Typography className={classes.paragraph}>
          The only times we’ll ever share your info:
        </Typography>

        <Typography className={classes.paragraph}>
          To provide products or services that fit with your use of the ADesk™
          system. To investigate, prevent, or take action regarding illegal
          activities, suspected fraud, situations involving potential threats to
          the physical safety of any person, violations of our Legal Copyright
          or as otherwise required by law. If ADesk™ is acquired by or merged
          with another company — we don’t plan on that, but if it happens —
          we’ll notify you well before any info about you is transferred and
          becomes subject to a different privacy policy.
        </Typography>

        <Typography className={classes.subHeader}>Law Enforcement</Typography>

        <Typography className={classes.paragraph}>
          ADesk™ won’t hand your data over to law enforcement unless a court
          order says we have to. We flat-out reject requests from local and
          federal law enforcement when they seek data without a court order. And
          unless we’re legally prevented from it, we’ll always inform you when
          such requests are made.
        </Typography>

        <Typography className={classes.subHeader}>
          Security & Encryption
        </Typography>

        <Typography className={classes.paragraph}>
          ADesk™ utilizes some of the most advanced technology for Internet
          security available today. All information while on the move between
          the browser and ADesk™ is protected from eavesdroppers with 256-bit
          Secure Socket Layer (SSL) encryption. The lock icon in the web browser
          lets users verify that it isn't a phishing site impersonating ADesk™
          and that data is secure in transit. The film office data is completely
          inaccessible to anyone else. All ADesk™ systems are hosted in a
          highly-secure server environment that uses firewalls and other
          advanced technology to prevent interference or access from outside
          intruders.
        </Typography>

        <Typography className={classes.paragraph}>
          Our data center is in the United States. If you are located in the
          European Union or elsewhere outside of the United States, please be
          aware that any information you provide to us will be transferred to
          the United States. By using our service, participating in any of our
          offerings and/or providing us with your information, you consent to
          this transfer.
        </Typography>

        <Typography className={classes.subHeader}>
          Changes & Questions
        </Typography>

        <Typography className={classes.paragraph}>
          ADesk™ may update this policy once and awhile or frequently, but we
          will notify you about significant changes by emailing you or by
          placing a prominent notice on our site. You can access, change or
          delete your personal information at any time by contacting us at
          support@adesk.com.
        </Typography>

        <Typography className={classes.paragraph}>
          Questions about this privacy policy? Please contact us, and we’ll be
          happy to answer them.
        </Typography>

        <Typography className={classes.paragraph}>
          Last Updated: November 08, 2019
        </Typography>

        <Typography className={classes.paragraph}>
          © Copyright Assignment Desk 2019. All rights reserved.
        </Typography>
      </div>
    )
  }
}

export default withStyles(styles)(PrivacyPolicy)
